<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Navigation } from "swiper";
import { ref, computed } from "vue";
import { buildApiUrlBasedOnCollection } from "@/helpers/apiHelper";

SwiperCore.use([Navigation]);

const jobsCollection = ref([]);

const props = defineProps({
    locale: {
        type: String,
        required: true,
    },
});

const urlParameters = [
    {
        key: "fields",
        value: "title,url,hero_image,small_description,period,period_short,country,salery,category,duration,job_duration,site",
    },
];

fetch(buildApiUrlBasedOnCollection("job", urlParameters, props.locale)).then((result) => {
    result.json().then((data) => {
        jobsCollection.value = data.data;
    });
});
</script>
<template>
    <swiper
        :loop="true"
        :slides-per-view="1"
        :breakpoints="{
            '1024': {
                slidesPerView: 3,
            },
        }"
        :navigation="{
            prevEl: '.slider-prev',
            nextEl: '.slider-next',
        }"
        :space-between="30"
    >
        <swiper-slide v-for="(slide, slideIndex) in jobsCollection" :key="slideIndex" class="w-full aspect-square">
            <div class="block group" itemscope itemtype="https://schema.org/JobPosting">
                <meta itemprop="salaryCurrency" content="EUR" />
                <meta v-if="slide.url" itemprop="url" :content="slide.url" />
                <div
                    itemprop="hiringOrganization"
                    itemscope
                    itemtype="https://schema.org/Organization"
                    style="display: none"
                >
                    <meta itemprop="name" content="TopAnimation" />
                </div>
                <meta v-if="slide.employmenttype" itemprop="employmentType" :content="slide.employmenttype" />
                <meta v-if="slide.industry" itemprop="industry" :content="slide.industry" />
                <meta
                    v-if="slide.workhours_start || slide.workhours_end"
                    itemprop="workHours"
                    content="{{ slide.workhours_start }} - {{ slide.workhours_end }}"
                />

                <div
                    class="col-span-1 w-full h-auto bg-white shadow-topanimation border border-gray-300 block focus:ring-2 focus:ring-teal-600 active:ring-2 active:ring-teal-600"
                >
                    <div class="h-40 xl:h-52 w-full overflow-hidden">
                        <img
                            v-if="slide.hero_image"
                            :src="slide.hero_image.small_w500_permalink"
                            :alt="slide.title"
                            class="w-full h-full object-cover"
                            itemprop="image"
                        />
                    </div>
                    <div class="px-5 py-3 min-h-[10rem]">
                        <h3
                            class="font-heading uppercase text-base lg:text-lg mb-2"
                            itemprop="title"
                            v-text="slide.title"
                        ></h3>
                        <div v-text="slide.small_description"></div>
                    </div>
                </div>
            </div>
        </swiper-slide>
        <div class="flex justify-center space-x-3">
            <button class="slider-prev p-3 hover:text-orange">
                <i class="fa-regular fa-long-arrow-left text-2xl"></i>
            </button>
            <button class="slider-next p-3 hover:text-orange">
                <i class="fa-regular fa-long-arrow-right text-2xl"></i>
            </button>
        </div>
    </swiper>
</template>
